/* eslint-disable @repo/internal/react/require-jsdoc */

/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { css, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const rootStyles = xcss({
	paddingInline: 'space.600',
	paddingBlock: 'space.600',
});

const quoteStyles = css({
	width: '85%',
	position: 'relative',
	font: token('font.heading.large'),
	fontWeight: token('font.weight.regular'),
	paddingInline: token('space.0'),
	'&::before': {
		position: 'absolute',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		fontSize: '5rem',
		insetBlockStart: token('space.negative.100'),
		insetInlineStart: token('space.negative.200'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		lineHeight: '1',
	},
	'&::after': {
		position: 'absolute',
		opacity: '0',
	},
});

export const Blockquote = ({ author, children }: { author: string; children: ReactNode }) => (
	<Stack space="space.100" xcss={rootStyles} alignInline="center">
		<blockquote css={quoteStyles}>{children}</blockquote>
		<Text size="large" color="color.text.subtlest">
			{author}
		</Text>
	</Stack>
);
